import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChatCircleDots, ArrowRight } from "@phosphor-icons/react";
import api from "@/api";
import { formatDateShortUK } from "@/pages/admin/_helpers";

/**
 * Big purple "Submit a question to <session>" CTA card.
 * Reads /info.featured_qa_session_id; renders nothing if it's not set.
 * Used at the top of the Programme page (and could be reused elsewhere).
 */
export function FeaturedQACard({ testid = "featured-qa-card" }) {
  const [session, setSession] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const i = await api.get("/info");
        const sid = i.data?.featured_qa_session_id;
        if (!sid) { setSession(null); return; }
        const s = await api.get(`/sessions/${sid}`);
        if (alive) setSession(s.data);
      } catch (err) {
        // Silently ignore - featured CTA is optional UI.
      }
    })();
    return () => { alive = false; };
  }, []);

  if (!session) return null;

  return (
    <Link
      to={`/program/${session.id}#ask`}
      data-testid={testid}
      className="block p-4 mb-4 rounded-sm bg-[#000000] text-[#FFFFFF] hover:bg-[#1c1c24] transition-colors group"
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-sm bg-[#FFFFFF]/15 grid place-items-center">
          <ChatCircleDots size={20} weight="duotone" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-mono-time text-[10px] uppercase tracking-widest text-[#FFFFFF]/70">
            Open all conference · {formatDateShortUK(session.date)} · {session.start_time}
          </div>
          <div className="font-display text-lg leading-tight mt-0.5 text-[#FFFFFF]">
            Submit a question to <span className="underline decoration-[#43C4E3] decoration-2 underline-offset-2">{session.title}</span>
          </div>
          <div className="text-xs text-[#FFFFFF]/80 mt-1">
            We&apos;ll work through the most-upvoted questions live in the session.
          </div>
        </div>
        <ArrowRight size={18} className="flex-shrink-0 mt-1 transition-transform group-hover:translate-x-1" />
      </div>
    </Link>
  );
}
